import API from "./API"

// const get = () => API.get("/fieldimagery/")

const get = payload => API.get("/fieldimagery/", { params: payload })

const post = payload => API.post("/fieldimagery/", payload)

export default { get, post }
